import React from 'react'

import { Chain } from '../../models'

interface ChainTableProps {
    chain: Chain
}

export const ChainTable = (props: ChainTableProps) => {
    const { chain } = props

    return (
        <table className='table'>
            <tbody>
                <tr>
                    <th>Name</th>
                    <td>{chain.name}</td>
                </tr>
                <tr>
                    <th>Chain Code</th>
                    <td>{chain.abbreviation}</td>
                </tr>
                <tr>
                    <th>Code</th>
                    <td>{chain.code}</td>
                </tr>
                <tr>
                    <th>Brand Id</th>
                    <td>{chain.supplier_brand_id}</td>
                </tr>
                <tr>
                    <th>Brand Name</th>
                    <td>{chain.supplier_brand_name}</td>
                </tr>
            </tbody>
        </table>
    )
}
